module.exports = __webpack_public_path__ + "media/tema_2.1_infografia_interactiva_productive_CF1.8ba76869.wav";